<template>
  <!-- Aviso al entrar al sistema: se va solo tocando la campana o entrando a Novedades -->
  <v-dialog :value="value" fullscreen persistent no-click-animation hide-overlay transition="fade-transition">
    <div class="news-notice" role="alertdialog" aria-modal="true" aria-labelledby="news-notice-title">
      <div class="news-notice__content">
        <button type="button" class="news-notice__bell" :disabled="marking" aria-label="Darme por enterado" title="Darme por enterado" @click="$emit('read')">
          <v-icon size="48" color="white">mdi-bell-ring-outline</v-icon>
          <span class="news-notice__count">{{ count > 99 ? "99+" : count }}</span>
        </button>

        <div>
          <h1 id="news-notice-title" class="news-notice__title">Hay novedades</h1>
          <p class="news-notice__subtitle">{{ count == 1 ? "Se publicó una novedad para vos." : "Se publicaron " + count + " novedades para vos." }}</p>
        </div>

        <ul v-if="latest.length > 0" class="news-notice__list">
          <li v-for="item in latest" :key="item.id">{{ item.title }}</li>
          <li v-if="count > latest.length" class="news-notice__more">y {{ count - latest.length }} más</li>
        </ul>

        <div class="news-notice__actions">
          <v-btn color="primary" depressed :disabled="marking" @click="$emit('open')">Ver novedades</v-btn>
          <v-btn text :loading="marking" @click="$emit('read')">Ya me enteré</v-btn>
        </div>

        <p class="news-notice__help">Tocá la campana para darte por enterado o entrá a Novedades. Siempre vas a poder volver a leerlas.</p>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "NewsNotice",
  props: {
    value: Boolean,
    count: Number,
    // [{ id, title }]
    latest: Array,
    marking: Boolean,
  },
};
</script>

<style scoped>
.news-notice {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  padding: 40px 16px;
  background: #f1f5f9;
  border-top: 6px solid #28536b;
}
.news-notice__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
  width: 100%;
  max-width: 560px;
  text-align: center;
}
.news-notice__bell {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 104px;
  height: 104px;
  border-radius: 50%;
  background: #28536b;
  cursor: pointer;
  animation: news-notice-pulse 2s ease-in-out infinite;
}
.news-notice__bell:focus-visible {
  outline: 3px solid #0f172a;
  outline-offset: 12px;
}
.news-notice__count {
  position: absolute;
  top: -2px;
  right: -2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 3px solid #f1f5f9;
  border-radius: 16px;
  background: #ea580c;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
}
.news-notice__title {
  margin: 0;
  font-family: "Artificial Intelligence", "Manrope", sans-serif;
  font-size: 38px;
  font-weight: 800;
  line-height: 1.2;
  color: #0f172a;
}
.news-notice__subtitle {
  margin: 6px 0 0;
  font-size: 17px;
  color: #475569;
}
.news-notice__list {
  width: 100%;
  margin: 0;
  padding: 6px 0;
  list-style: none;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  text-align: left;
}
.news-notice__list li {
  padding: 10px 16px;
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
  overflow-wrap: anywhere;
}
.news-notice__list li + li {
  border-top: 1px solid #f1f5f9;
}
.news-notice__list .news-notice__more {
  font-weight: 400;
  color: #64748b;
}
.news-notice__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}
.news-notice__help {
  max-width: 440px;
  margin: 0;
  font-size: 13px;
  color: #64748b;
}
@keyframes news-notice-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 10px rgba(40, 83, 107, 0.15);
  }
  50% {
    box-shadow: 0 0 0 18px rgba(40, 83, 107, 0.06);
  }
}
@media (prefers-reduced-motion: reduce) {
  .news-notice__bell {
    animation: none;
    box-shadow: 0 0 0 10px rgba(40, 83, 107, 0.15);
  }
}
@media (max-width: 600px) {
  .news-notice__title {
    font-size: 30px;
  }
}
</style>
